import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Paragraph, Text} = Typography;
const Content = Layout;

const UnoM = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Marketing</Paragraph>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Market Size</Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>Growth in the Lateral Flow Assays (LFA) market is mainly driven by factors such as increasing numbers of various chronic and infectious diseases, growth in promoting health awareness, high demand for point-of-care testing, and advantages of LFA rapid tests over time-spending laboratory tests. The LFA market is segmented on the basis of product, technique, application, end user, and region [1]. Taking this into consideration, we did research about the market size of iMoAge.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-47.png'/>
          <p><b>Fig. 1.</b>. Market size of iMoAge multiplex lateral flow assay. In the TAM it was considered the global market of lateral flow assays. In the SAM it was considered only the region of Mexico. In the SOM it was considered the  inflammaging application.[2-4]</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default UnoM;
